import type { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import { FloatingButtonGroup } from '../../../../common/components/FloatingButtonGroup';
import { ScrollToTopButton } from '../../../../common/components/ScrollToTopButton';

interface SeedingCampaignDetailLayoutProps {
  children: ReactNode;
  /** 하단 sticky CTA — SeedingFloatingActionBar 또는 null. sticky 라 본문 끝과 자연스럽게 같이 위치, pb 보정 불필요 */
  floatingCta?: ReactNode;
  /** 스크롤 위로 FAB 노출 여부 (r-08 / p-07 은 false) */
  showScrollToTop?: boolean;
  className?: string;
}

// SeedingFloatingActionBar 의 고정 높이 (py-[12px] + Button 48px = 72px).
// ScrollToTopButton FAB 의 bottom offset 만 사용 — CTA 위로 띄울 때.
const FLOATING_CTA_HEIGHT = 72;

export const SeedingCampaignDetailLayout = ({
  children,
  floatingCta,
  showScrollToTop = true,
  className,
}: SeedingCampaignDetailLayoutProps) => (
  <div className={twMerge('flex flex-col flex-1 bg-white', className)}>
    {/* content wrapper — sticky CTA 형제로서 grow 로 남은 공간 채움. pb-72 는 NoticeSection 자체가 책임. */}
    <div className="grow">{children}</div>
    {showScrollToTop && (
      <FloatingButtonGroup.Layout style={floatingCta ? { bottom: FLOATING_CTA_HEIGHT } : undefined}>
        <FloatingButtonGroup.Container className="safe-area-bottom">
          <ScrollToTopButton />
        </FloatingButtonGroup.Container>
      </FloatingButtonGroup.Layout>
    )}
    {floatingCta}
  </div>
);
